import React from 'react';
import zoneAImg from '../../assets/screens/zone-a.png';
import CardReaderScreen from '../../molecules/CardReaderScreen';

const HomeRC = () => (
  <CardReaderScreen backgroundImage={zoneAImg} fadeDuration="500ms" />
);

export default HomeRC;
